import { useConnection } from 'wagmi';

export default function ModalConfirmTxContent({ header }: { header: string }) {
  const { connector } = useConnection();
  const wallet = connector?.name ?? '';

  return (
    <div className="rounded-sm bg-background-secondary px-[32px] pt-2xl pb-[40px] max-md:w-full max-md:rounded-none max-md:px-xl max-md:py-2xl">
      <div className="text-body-lg font-bold text-gray">{header}</div>
      <div className="mt-xl w-133.5 text-h1 font-bold text-gray-text max-md:w-auto">
        Confirm the transaction requested by {wallet}
      </div>
      <div className="mt-[32px] w-133.5 text-body-lg text-gray-text max-md:mt-2xl max-md:w-auto max-md:text-body-md">
        You will be asked to confirm a transaction in your {wallet} wallet.
      </div>
    </div>
  );
}
